import AirDatepicker from "air-datepicker";
import localeEn from 'air-datepicker/locale/en';  

const DatePicker = () => {
  const inputField = document.querySelector("input#birth-date"); 
  let calendarInstance = null;

  if (inputField) {
    inputField.addEventListener("click", (event) => {
      event.stopPropagation(); 

      const calendarElement = document.querySelector(".auth__calendar");

      if (!calendarElement) {
        console.error("calendarElement is not defined");
        return;
      }

      if (calendarInstance) {
        calendarInstance.destroy();
        calendarInstance = null;
      } else {
        calendarInstance = new AirDatepicker(".auth__calendar", {
          locale: localeEn,
          autoClose: false,
          view: 'days', 
          minView: 'days',
          onSelect({ date }) {
            if (date) {
              const formattedDate = date.toLocaleDateString('en-GB', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
              }).replace(/\//g, '.');
              inputField.value = formattedDate;

              calendarInstance.destroy();
              calendarInstance = null;
            }
          }
        });
      }
    });

    document.addEventListener("click", (event) => {
      const calendarElement = document.querySelector(".auth__calendar");

      if (
        calendarInstance &&
        !inputField.contains(event.target) && 
        !calendarElement.contains(event.target) 
      ) {
        calendarInstance.destroy(); 
        calendarInstance = null;
      }
    });
  }
}

export default DatePicker;
